import type { ICatalog, IModuleSummary } from '@platform/core/types';
import { BA_COVERAGE } from './baCoverageSpec';
import type { IBaRowSource } from './IBaRowSource';
import type { IOrderedTypeSummary } from './IOrderedTypeSummary';

/**
 * Рядки матриці покриття (прототип v4: [...BA_SYS, ...ws.modules] без повторів): системні рядки, далі кожна реалізована таблиця
 * встановлених модулів простору в порядку `order` каталогу (ws.modules прототипу: дочірні — серед модулів). `nameOf` дає базову
 * англійську назву (значення поля `module` аналізу): головна таблиця — назва модуля, дочірня — назва таблиці. Категорія — та, яку показує
 * прототип (`displayCategory`: справи — «Управління», документи — «Документи», проєкти — «Проєкти»), інакше категорія модуля. Чиста функція.
 */
export function baRowsOf(catalog: ICatalog | undefined, nameOf: (module: IModuleSummary, rt: IOrderedTypeSummary) => string): IBaRowSource[] {
  const system = BA_COVERAGE.systemRows.map((value, i) => ({ value, category: i === 0 ? '@platform' : '@system' }));
  const types = (catalog?.modules ?? []).filter((m) => m.installed)
    .flatMap((m) => (m.recordTypes as IOrderedTypeSummary[]).filter((rt) => typeof rt.order === 'number').map((rt) => ({ m, rt })))
    .sort((a, b) => (a.rt.order as number) - (b.rt.order as number));
  const rows: IBaRowSource[] = [...system, ...types.map(({ m, rt }) => ({ value: nameOf(m, rt), category: m.displayCategory ?? m.category }))];
  return rows.filter((row, i) => rows.findIndex((x) => x.value === row.value) === i);
}
